<template>
  <div>
    <a-spin :spinning="loading">
      <vxe-grid
        ref="xGrid"
        column-key
        class="column-sortable-grid"
        v-bind="gridOptions"
        @cell-click="cellClick"
        @cell-dblclick="cellDbClick"
        @form-submit="formSubmit"
      >
        <template v-slot:default="{ row }">
          <slot name="startTime" v-bind:row="row"></slot>
        </template>
        <template v-slot:default="{ row }">
          <slot name="endTime" v-bind:row="row"></slot>
        </template>
        <template v-slot:default="{ row }">
          <slot name="operate" v-bind:row="row"></slot>
        </template>
        <template v-slot:detail="{row,column}">
          <span
            style="text-decoration: underline;color: #0158ff;cursor: pointer"
            @click="$parent.updateRow({row})"
          >{{ row[column.property] }}</span>
        </template>
<!--       下载附件-->
        <template v-slot:download="{row}">
          <!--<span
                  style="text-decoration: underline;color: #0158ff;cursor: pointer;text-align: center"
                  @click="$parent.updateRow({row})"
          >下载该附件</span>-->
          <a v-if="row.status === 2 && (row.val3 == '成员管理' || row.val3 == '角色管理' || row.val3 =='系统日志')" style="text-decoration: underline;color: #0158ff;" :href="api.temp.FILE_PATH + row.url" target="_blank">
            下载该附件
          </a>
          <a v-if="row.status === 2 && row.val3!='成员管理'&& row.val3!='角色管理'&& row.val3!='系统日志'" style="text-decoration: underline;color: #0158ff;" :href="api.temp.FILE_EXPORT + row.url" target="_blank">
            下载该附件
          </a>
          <a v-if="row.status != 2" style="text-decoration: underline;color: #999999;">
            下载该附件
          </a>
        </template>
        <template slot="default"></template>
        <template v-slot:pics="{ row }">
          <a :href="api.temp.FILE_PATH + row.brandLogoUrl" target="_blank">
            <img :src="api.temp.FILE_PATH + row.brandLogoUrl" style="height: 30px;"/>
          </a>
        </template>
        <template v-slot:toolbar_buttons>
          <vxe-button v-if="toolbarConfig.addData" v-auth="'ADD'" @click="$emit('toolbar-addData', $event)">
            <a-icon type="diff"/>
            新增
          </vxe-button>
          <vxe-button v-if="toolbarConfig.delData" @click="$emit('toolbar-delData', $event)">
            <a-icon type="delete"/>
            删除
          </vxe-button>
          <!--        <vxe-button v-if="toolbarConfig.delData" @click="delData">-->
          <!--          <a-icon type="delete"/>-->
          <!--          删除-->
          <!--        </vxe-button>-->
          <vxe-button v-if="toolbarConfig.reloadData" @click="reloadData">
            <a-icon type="redo"/>
            刷新
          </vxe-button>
          <slot
            v-if="toolbarConfig&&toolbarConfig.templatelSlots"
            :name="toolbarConfig&&toolbarConfig.templatelSlots"
          ></slot>
        </template>
      </vxe-grid>
    </a-spin>
  </div>
</template>

<script>
import Vue from 'vue'
import XEAjax from 'xe-ajax'
import VXETable from 'vxe-table'
import tableUtil from '@/utils/tableUtil'
import XEUtils from 'xe-utils'
import 'vxe-table/lib/style.css'
import { delList, list } from '@/services/dataSource'

import VXETablePluginAntd from 'vxe-table-plugin-antd'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import 'vxe-table-plugin-antd/dist/style.css'
import moment from 'moment'
import api from '@/services/api'

console.log(api)

VXETable.use(VXETablePluginAntd)
VXETable.use(VXETablePluginExportXLSX)

Vue.use(VXETable)

/**
 * 如果value值有效(除了null/undefined/NaN之外的所有值)则返回value，否则返回defaultValue
 * @param value
 * @param defaultValue
 * @returns
 */
function valueOrDefault (value, defaultValue) {
  return typeof value === 'undefined' || value === null || isNaN(value)
    ? defaultValue
    : value
}

/**
 * 工厂方法，用来提供各种设置的默认值
 */
const factory = {

  /**
   * 根据类型生成首列选择栏r>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param type 选择框内容 默认为checkbox
   * @returns {}
   */
  makeColumnDefault (type = 'checkbox') {
    if (type === 'radio') {
      return { type: 'radio', field: '#', width: 50, align: 'center' }
    } else {
      return { type: 'checkbox', field: '#', width: 50, align: 'center' }
    }
  },
  /**
   * 生成一个序号列
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param width 50
   * @returns {}
   */
  makeColumnSeqDefault (width = 50) {
    return { type: 'seq', title: '序号', width: width, align: 'center' }
  },

  /**
   * 生成一个空的checkbox列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @param width 默认值为40
   * @returns {}
   */
  makeColumnCheckboxDefault (field = '#', width = 50) {
    return { type: 'checkbox', field: field, width: width, align: 'center' }
  },
  /**
   * 生成一个空的radio列定义<br>
   * checkbox列需要有对应的checkboxConfig才能显示field的值，如果不需要显示值，可以指定一个不存在的field<br>
   * @param field 默认值为#
   * @returns {}
   */
  makeColumnRadioDefault (field = '#') {
    return { type: 'radio', field: field, width: 50, align: 'center' }
  },
  /**
   * 创建列定义
   * @param field 字段名，或者一个column对象（如果使用column对象，则只能传一个参数）
   * @param title 标题
   * @param width
   * @param align
   * @param resizable 是否可调整大小
   * @param formatter
   * @param type
   * @param sortable
   * @param filters
   * @returns {{formatter: null, field: *, resizable: boolean, width: (*|number), sortable: boolean, filters: *[], title: *, align: string, type: null, filterMultiple: boolean}|any}
   */
  makeColumn (
    field,
    title,
    width,
    align = 'left',
    resizable = true,
    formatter = null,
    type = null,
    sortable = false,
    filters = ''
  ) {
    if (arguments.length === 1 && typeof field == 'object' && field) {
      // 传入column object，则添加一些默认值
      return Object.assign(
        {
          field: field.field,
          title: field.title || field.field,
          width: field.width,
          resizable: valueOrDefault(field.resizable, true),
          sortable: valueOrDefault(field.sortable, false),
          headerAlign: 'center'
        },
        field
      )
    } else {
      // 传入参数表
      return {
        field,
        title: title || field,
        width:
          width === null || typeof width === 'undefined' ? width : width || 100,
        align,
        resizable,
        formatter,
        type,
        sortable,
        filters,
        filterMultiple: false,
        headerAlign: 'center'
      }
    }
  },
  /**
   * 获取高级筛选列配置
   * @param columns 列信息
   * @param tmpFormConfig 配置
   * @param otherConfig 增量配置
   * @returns
   */
  makeFormConfig (columns, tmpFormConfig, otherConfig = { rowNum: null }) {
    columns = JSON.parse(JSON.stringify(columns))
    let formConfig = {
      titleWidth: 100,
      titleAlign: 'right',
      data: {},
      items: []
    }
    columns.map(function (e, index) {
      if (e.field === '#') {
        columns.splice(index, 1)
      }
    })
    const itemRenderMap = {
      select: (options, title, placeholder) => ({
        name: 'ASelect',
        options,
        props: { placeholder: placeholder || '请选择' + title }
      }),
      'multi-select': (options, title, placeholder) => ({
        name: 'ASelect',
        options,
        props: {
          mode: 'multiple',
          placeholder: placeholder || '请选择' + title
        }
      }),
      "search-select": (options, title, placeholder) => ({
        name: "ASelect",
        options,
        props: {
          showSearch: true,
          placeholder: placeholder || "请选择" + title,
        },
      }),
      switch: (options, title, placeholder) => ({
        name: 'ASwitch',
        options,
        props: { placeholder: placeholder || '请选择' + title }
      }),
      number: (options, title, placeholder) => ({
        name: 'AInputNumber',
        options,
        props: { placeholder: placeholder || '请输入' + title }
      }),
      dateRange: (options) => ({
        name: 'ARangePicker',
        options,
        props: { placeholder: ['开始时间', '结束时间'] }
      }),
      date: (options, title, placeholder) => ({
        name: 'ADatePicker',
        options,
        props: { placeholder: placeholder || '请选择' + title }
      }),
      month: (options, title, placeholder) => ({
        name: 'AMonthPicker',
        options,
        props: { placeholder: placeholder || '请选择' + title }
      })
    }

    const map = {}
    for (let index = 0; index < tmpFormConfig.length; index++) {
      const element = tmpFormConfig[index]
      map[element?.field] = element
    }
    let searchNum = 0
    let span = 6
    if (otherConfig.rowNum) {
      span = 24 / otherConfig.rowNum
    }
    tmpFormConfig.forEach((e, i) => {
      if (e.field) {
        searchNum++
        let arr = columns.filter((col) => {
          return col.field === e.field
        })
        let field, title,
          placeholder = tmpFormConfig[i].placeholder || '',
          type = tmpFormConfig[i].type,
          options = tmpFormConfig[i].options,
          customSearch = !!tmpFormConfig[i].customSearch,//自定义搜索
          itemRender = itemRenderMap[tmpFormConfig[i].type] || ''
        if (arr.length) {
          field = arr[0].field
          title = arr[0].title
        } else {
          field = tmpFormConfig[i].field
          title = tmpFormConfig[i].title || '未配置标题'
        }
        formConfig.items.push({
          baseCode: (type === 'select' && tmpFormConfig[i].baseCode) || '',
          auditStatus: (type === 'select' && tmpFormConfig[i].auditStatus) || '',
          field,
          title,
          customSearch,
          span: type === 'dateRange' ? span * 2 : span,
          folding: otherConfig.rowNum ? searchNum > otherConfig.rowNum : searchNum > 4,
          itemRender: itemRender
            ? itemRender(options, title, placeholder)
            : {
              name: 'AInput',
              props: { placeholder: placeholder || '请输入' + title }
            },
          titleSuffix: (type === 'multi-select') ? {
            icon: 'fa fa-user-o'
          } : null
        })

        /**
         * 在列中时增加额外的配置
         */
        if (arr.length) {
          if (arr[0].slots) {
            formConfig.items[formConfig.items.length - 1]['slots'] = arr[0].slots
          }
          if (arr[0].events) {
            formConfig.items[formConfig.items.length - 1]['events'] = arr[0].events
          }
          formConfig.data[arr[0].field] = type === 'multi-select' || type === 'dateRange' ? [] : ''
        }
      }
    })

    /**
     * 旧的筛选表单只能从列中赋值
     */
    // let searchNum = 0;
    // for (let index = 0; index < columns.length; index++) {
    //   const col = columns[index];
    //   const c = map[col.field];
    //   if (!c) continue;
    //   searchNum++;
    //   const itemRender = itemRenderMap[c.type];
    //   let span = 6;
    //   if (otherConfig.rowNum) {
    //     span = 24 / otherConfig.rowNum;
    //   }
    //
    //   formConfig.items.push({
    //     field: col.field,
    //     title: col.title,
    //     span: c.type === 'dateRange' ? span * 2 : span,
    //     folding: otherConfig.rowNum ? searchNum > otherConfig.rowNum : searchNum > 4,
    //     itemRender: itemRender
    //         ? itemRender(c.options, col.title)
    //         : {
    //           name: "AInput",
    //           props: {placeholder: "请输入" + col.title},
    //         },
    //     titleSuffix: (c.type === 'multi-select') ? {
    //       icon: 'fa fa-user-o'
    //     } : null
    //   });
    //   if (col.slots) {
    //     formConfig.items[formConfig.items.length - 1]['slots'] = col.slots
    //   }
    //   if (col.events) {
    //     formConfig.items[formConfig.items.length - 1]['events'] = col.events
    //   }
    //   formConfig.data[col.field] = c.type === "multi-select" || c.type === 'dateRange' ? [] : "";
    // }

    formConfig.items.push({
      span: otherConfig.rowNum ? (24 / otherConfig.rowNum) : 6,
      align: 'center',
      collapseNode: otherConfig.rowNum ? searchNum > otherConfig.rowNum : searchNum > 4,
      itemRender: {
        name: '$buttons',
        children: [
          { props: { type: 'submit', content: '搜索', status: 'primary' } },
          { props: { type: 'reset', content: '重置' } }
        ]
      }
    })
    return formConfig
  },
  /**
   * 获取工具栏配置
   * @param buttons 按钮列表
   * @returns
   */
  makeToolbarConfig (buttons = {}) {
    return Object.assign({}, {
      addData: true,
      delData: true,
      reloadData: false,
      slots: {
        buttons: 'toolbar_buttons'
      },
      refresh: true,
      import: true,
      export: true,
      print: false,
      zoom: false,
      custom: true
    }, buttons)
  },
  /**
   * 获取checkbox配置
   * @param columns columns列表，将从列表中寻找第一个type=checkbox的列，并据此生成配置
   * @returns
   */
  makeCheckboxConfig (columns = []) {
    const checkboxColumn = (columns || []).find((c) => c.type === 'checkbox')
    return checkboxColumn
      ? {
        labelField: checkboxColumn.field,
        reserve: true,
        highlight: true,
        range: true
      }
      : null
  },
  /**
   * 生成列表页弹出层配置
   */
  makePopConfig (funcArr) {
    let popConfig = {}
    if (!funcArr || !funcArr.length || !Array.isArray(funcArr)) {
      return {}
    }
    funcArr.forEach(val => {
      popConfig[val] = {
        show: false,
        row: {},
        id: -1
      }
    })
    return popConfig
  },
  makePrintConfig (columns) {
    const printColumns = (columns || []).filter((col) => col.field).map((col) => ({ field: col.field }))
    return printColumns.length ? { columns: printColumns } : null
  },
  /**
   * 分页配置
   * @param defaultPageSize 如果分页列表不包含defaultPageSize则将其加入列表并排序
   * @returns {{pageSizes: number[], pageSize: number}}
   */
  makePagerConfig (defaultPageSize = 20) {
    let pageSizes = [10, 20, 50, 100, 200]
    if (pageSizes.indexOf(defaultPageSize) === -1) {
      pageSizes.push(defaultPageSize)
      pageSizes.sort()
    }
    return {
      pageSize: defaultPageSize,
      pageSizes: pageSizes
    }
  },
  makeEditConfig () {
    return {
      trigger: 'click',
      mode: 'row',
      showStatus: true
    }
  },
  makeEditRuleRequired (messageOrColumn) {
    return {
      required: true,
      message:
        typeof messageOrColumn === 'string'
          ? messageOrColumn
          : (messageOrColumn.title || messageOrColumn.field) + '必须填写'
    }
  },
  makeEditRuleRange (messageOrColumn, min, max) {
    return {
      min,
      max,
      message:
        typeof messageOrColumn === 'string'
          ? messageOrColumn
          : (messageOrColumn.title || messageOrColumn.field) +
          `长度应在${ min }-${ max }字符之间`
    }
  },
  /**
   * 根据列定义的editRules构建标准editRules配置<br>
   * @param columns 列定义 [{ field: '', editRules: [{ required: true }, { min: 0, max: 1 }, ...] }]
   * @returns { COLUMN_FILED: [ RULE1, RULE2, ... ], ... }
   */
  makeEditRules (columns) {
    const rules = {}
    columns.forEach((col) => {
      if (col.editRules) {
        if (!XEUtils.isArray(col.editRules)) {
          console.warn('列定义的editRules应是一个数组')
        } else {
          rules[col.field] = col.editRules.map((rule) => {
            if (rule) {
              const editRule = Object.assign({}, rule)
              if (typeof rule.required === 'boolean') {
                editRule.message = `${ col.title || col.field }必填`
              } else if (
                typeof rule.min === 'number' ||
                typeof rule.max === 'number'
              ) {
                editRule.message = `${ col.title ||
                col.field }长度应在${ rule.min || 0 }-${ rule.max || 0 }之间`
              } else {
                console.info('不支持的editRule', rule)
              }
              return editRule
            }
          })
        }
      }
    })
    return rules
  }
}

/**
 * 组件定义
 */
export default {
  name: 'XGrid',
  components: {},
  props: {
    id: String,
    columnSortable: {
      type: Boolean,
      default: true
    },
    columnResizable: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    showHeaderOverflow: {
      type: Boolean,
      default: true
    },
    showOverflow: {
      type: Boolean,
      default: true
    },
    highlightHoverRow: {
      type: Boolean,
      default: true
    },
    keepSource: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default () {
        return document.body.clientHeight - 48 - 64
      }
    },
    /**
     * 数据集
     */
    data: Array,
    rowId: String,
    /**
     * 列定义
     */
    columns: Array,
    /**
     * 复选框设置<br>
     * checkbox列需要有对应的checkboxConfig才能显示field的值，如果checkbox column不需要显示值，可以指定一个不存在的field<br>
     * {
     *   labelField: 与Checkbox Column的field一致,
     *   reserve: true,
     *   highlight: true,
     *   range: true
     * }
     */
    checkboxConfig: Object,
    /**
     * 数据源API地址
     */
    url: String,
    /**
     * 分页配置<br>
     * { pageSize: NUMBER, pageSizes: [NUMBER, NUMBER, ...] }
     */
    pagerConfig: Object,
    /**
     * 查询表单配置<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/form<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api<br>
     * {
     *   titleWidth: NUMBER,
     *   titleAlign: 'right',
     *   data: {
     *   }
     *   items: [
     *     { field: FIELD, title: TITLE, span: NUMBER, itemRender: {name: '$input', props: {placeholder: PLACEHOLDER}} },
     *     ...
     *   ]
     * }
     */
    formConfig: Object,
    /**
     * 工具栏配置<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/toolbar<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/customToolbar<br>
     * {
     *   buttons: [
     *     { code: 'myInsert', name: '新增', status: 'success', disabled: false },
     *     ...
     *   ],
     *   refresh: true,
     *   import: true,
     *   export: true,
     *   print: true,
     *   zoom: true,
     *   custom: true
     * }
     */
    toolbarConfig: Object,
    /**
     * 是否可编辑，如果设置为true，则默认生成单击行编辑的editConfig
     */
    editable: {
      type: Boolean,
      default: null
    },
    /**
     * 编辑设置，如果editable没有赋值，而且指定了editConfig也会打开编辑<br>
     * https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/edit<br>
     * {
     *   trigger: 'click',
     *   mode: 'row',
     *   showStatus: true
     * }
     */
    editConfig: Object,
    /**
     * 编辑规则
     *
     */
    editRules: Object,
    /**
     * 打印设置
     */
    printConfig: Object,
    /**
     * 导入设置<br>
     * {
     *   remote: true,
     *   importMethod: this.importMethod,
     *   types: ['xlsx'],
     *   modes: ['insert']
     * }
     */
    importConfig: Object,
    /**
     * 导出设置<br>
     * {
     *   remote: true,
     *   exportMethod: this.exportMethod,
     *   types: ['xlsx'],
     *   modes: ['current', 'selected', 'all']
     * }
     */
    exportConfig: Object,
    /**
     * 单元格双击时打开详情
     */
    cellDbClick: {
      type: Function,
      default () {
        return ''
      }
    },
    cellClick: {
      type: Function,
      default () {
        return ''
      }
    },
    /**
     * 需要给表格传递的其他参数
     */
    otherParams: {
      type: Object,
      default: null
    }
  },
  data () {
    // console.info("XGrid data =", this.data);
    return {
      api,
      loading: false,
      // 配置参考：
      // https://xuliangzhan_admin.gitee.io/vxe-table/#/grid/api
      // https://xuliangzhan_admin.gitee.io/vxe-table/#/table/grid/basic
      gridOptions: {
        border: this.border,
        resizable: this.columnResizable,
        showHeaderOverflow: this.showHeaderOverflow,
        showOverflow: this.showOverflow,
        highlightHoverRow: this.highlightHoverRow,
        keepSource: this.keepSource,
        id: this.id,
        height: this.height,
        rowId: this.rowId || 'id',
        url: this.url,
        customConfig: {
          storage: true,
          checkMethod: this.checkColumnMethod
        },
        printConfig: this.printConfig,
        sortConfig: {
          trigger: 'cell'
        },
        filterConfig: {
          remote: true
        },
        pagerConfig: this.pagerConfig || factory.makePagerConfig(20),
        formConfig: this.formConfig,
        toolbarConfig: this.toolbarConfig,
        proxyConfig: {
          seq: true, // 启用动态序号代理
          sort: true, // 启用排序代理
          filter: false, // 启用筛选代理
          form: true, // 启用表单代理
          props: {
            // 分页结果属性名
            // 参考代码：index.common.dev.js 20604
            // vxe-table/lib/grid/src/grid.js 739
            // https://gitee.com/xuliangzhan_admin/vxe-table/blob/v3/packages/grid/src/grid.js 546
            result: 'data.list',
            total: 'data.totalCount'
          },
          ajax: {
            // 接收 Promise 对象
            query: ({ page, sort, filters, form }) => {
              // this.formConfig
              let props = [], formData = {}
              for (let p in form) {
                props.push(p)
              }
              for (let f = 0; f < props.length; f++) {
                if (form[props[f]]) {
                  if (this.formConfig.items[f].itemRender.name === 'ASelect') {
                    /**多选框 */
                    if (this.formConfig.items[f].itemRender.props.mode &&
                      this.formConfig.items[f].itemRender.props.mode === 'multiple') {

                      if (this.formConfig.items[f].customSearch) {
                        formData[props[f]] = form[props[f]].join(',')
                      } else {
                        formData['filter.inNumbers.' + props[f]] = form[props[f]].join(',')
                      }
                    } else {
                      /**单选框 */
                      if (this.formConfig.items[f].customSearch) {
                        formData[props[f]] = form[props[f]]
                      } else {
                        formData['filter.eq.' + props[f]] = form[props[f]]
                      }
                    }
                  } else if (this.formConfig.items[f].itemRender.name === 'ASwitch') {
                    if (this.formConfig.items[f].customSearch) {
                      formData[props[f]] = form[props[f]]
                    } else {
                      formData['filter.eq.' + props[f]] = form[props[f]]
                    }
                  } else if (this.formConfig.items[f].itemRender.name === 'AInputNumber') {
                    if (this.formConfig.items[f].customSearch) {
                      formData[props[f]] = form[props[f]]
                    } else {
                      formData['filter.eq.' + props[f]] = form[props[f]]
                    }
                  } else if (this.formConfig.items[f].itemRender.name === 'ARangePicker') {
                    if (this.formConfig.items[f].customSearch) {
                      if (form[props[f]][0] && form[props[f]][1]) {
                        formData[props[f]] = moment(form[props[f]][0]).format('YYYY-MM-DD') + '~' + moment(form[props[f]][1]).format('YYYY-MM-DD')
                      }
                    } else {
                      if (form[props[f]][0] && form[props[f]][1]) {
                        formData['filter.dateRange.' + props[f]] = moment(form[props[f]][0]).format('YYYY-MM-DD') + '~' + moment(form[props[f]][1]).format('YYYY-MM-DD')
                      }
                    }
                  } else if (this.formConfig.items[f].itemRender.name === 'ADatePicker') {
                    if (this.formConfig.items[f].customSearch) {
                      if (form[props[f]]) {
                        formData[props[f]] = moment(form[props[f]], 'YYYY-MM-DD')
                      }
                    } else {
                      if (form[props[f]]) {
                        formData['filter.eq.' + props[f]] = moment(form[props[f]], 'YYYY-MM-DD')
                      }
                    }
                  } else if (this.formConfig.items[f].itemRender.name === 'AMonthPicker') {
                    //计划管理 独有
                    if (this.formConfig.items[f].customSearch) {
                      if (form[props[f]]) {
                        //  qf01 formData[props[f]] = moment(form[props[f]], 'YYYY-MM')
                        formData[props[f]] = moment(form[props[f]]).format('YYYY-MM')
                      }
                    } else {
                      if (form[props[f]]) {
                        // formData['filter.lt.' + props[f]] = moment(form[props[f]], 'YYYY-MM-DD');
                        console.log(form[props[f]]._d)
                        let year = form[props[f]]._d.getFullYear()
                        let month = form[props[f]]._d.getMonth() + 1
                        let day = form[props[f]]._d.getDay()
                        console.log(year, month, day)
                        formData['filter.le.' + props[f]] = year + '-' + month + '-' + '01'
                        formData['filter.gt.planEndTime'] = year + '-' + month + '-' + '01'
                      }
                    }
                  } else {
                    if (this.formConfig.items[f].customSearch) {
                      formData[props[f]] = form[props[f]].replace(/(^\s*)|(\s*$)/g, '')
                    } else {
                      formData['filter.like.' + props[f]] = form[props[f]].replace(/(^\s*)|(\s*$)/g, '')
                    }
                  }
                }
              }
              // 处理排序条件
              const queryParams = Object.assign(
                {
                  sort: sort.property,
                  order: sort.order
                },
                formData,
                {
                  page: page.currentPage,
                  limit: page.pageSize
                }
              )
              localStorage.setItem('queryParams', JSON.stringify(queryParams))
              // 处理筛选条件
              filters.forEach(({ property, values }) => {
                console.log({ property, values })
                queryParams[property] = values.join(',')
              })
              if (this.otherParams && typeof this.otherParams === 'object') {
                Object.assign(queryParams, this.otherParams)
              }

              return list(this.url, queryParams).catch()
            },
            delete: (delRows) => {
              if (!this.gridOptions.rowId || this.gridOptions.rowId.length === 0) {
                console.error('设置rowId主键')
                return false
              }
              const queryParams = delRows.map(e => {
                return e[this.rowId]
              })
              let textArr = this.$refs.xGrid.$refs['pagerWrapper'].getElementsByClassName('vxe-pager--total')[0].innerText.split(' ')
              this.$refs.xGrid.$refs['pagerWrapper'].getElementsByClassName('vxe-pager--total')[0].innerText = textArr[0] + ' ' + (textArr[1] * 1 - 1) + ' ' + textArr[2]

              delList(this.url, {
                data: queryParams
              }).then(() => {
                // this.$refs.xGrid.remove(delRows);
                this.$refs.xGrid.remove(delRows)
                //遍历了组件中的dom 改变了page组件中的数量
                let textArr = this.$refs.xGrid.$refs['pagerWrapper'].getElementsByClassName('vxe-pager--total')[0].innerText.split(' ')
                this.$refs.xGrid.$refs['pagerWrapper'].getElementsByClassName('vxe-pager--total')[0].innerText = textArr[0] + ' ' + (textArr[1] * 1 - 1) + ' ' + textArr[2]
              }).catch(error => console.log('删除失败', error))
            },
            save: ({ body }) =>
              XEAjax.post(
                'https://api.xuliangzhan.com:10443/api/pub/save',
                body
              )
          }
        },
        columns: this.columns,
        importConfig: this.importConfig,
        exportConfig: this.exportConfig,
        checkboxConfig: this.checkboxConfig,
        editRules: this.editRules,
        editConfig:
          this.editable || (this.editable !== false && this.editConfig)
            ? this.editConfig || factory.makeEditConfig()
            : null

      }
    }
  },
  created () {
    // this.findSexList();
    if (this.columnSortable) {
      tableUtil.vxe.initColumnDragging(this, 'xGrid')
    }
  },
  beforeCreate () {
    // console.info(this);
  },
  beforeMount () {
    // console.info(this);
  },
  mounted () {
    // console.info(this);
  },
  beforeDestroy () {
    // TODO 在初始化时绑定销毁回调
    if (this.columnSortable) {
      this.sortableInstance.destroy()
    }
  },
  methods: {
    checkColumnMethod ({ column }) {
      return !['nickname', 'role'].includes(column.property)
    },
    refresh () {
      this.$refs.xGrid.commitProxy('query')
    },
    addData () {
      console.log('功能未实现 methods--addData')
    },
    delData (tips) {
      let checkIndex = this.$refs['xGrid'].columns.findIndex(item => {
        return item.type === 'checkbox'
      })
      let radioIndex = this.$refs['xGrid'].columns.findIndex(item => {
        return item.type === 'radio'
      })
      let selectRecords
      if (checkIndex > -1) {
        selectRecords = this.$refs.xGrid.getCheckboxRecords()
      } else if (radioIndex > -1) {
        if (this.$refs.xGrid.getRadioRecord()) {
          selectRecords = [this.$refs.xGrid.getRadioRecord()]
        } else {
          selectRecords = []
        }
      } else {
        console.info('表格无选中类型')
        selectRecords = []
      }
      if (selectRecords && selectRecords.length === 0) {
        VXETable.modal.message({ message: '请至少选择一条数据', status: 'warning' })
        return false
      }
      //配置个地址。进行删除
      let _that = this
      VXETable.modal.confirm(typeof tips === 'string' ? tips : tips = '您确定要删除该数据?').then(type => {
        if (type === 'confirm') {
          _that.gridOptions.proxyConfig.ajax.delete(selectRecords)
        }
      })
    },
    reloadData () {
      this.refresh()
    },
    formSubmit () {

    },
    getSelectData (type) {
      let selectRecords
      if (type === 'radio') {
        selectRecords = this.$refs.xGrid.getRadioRecord()
      } else if (type === 'checkbox') {
        selectRecords = this.$refs.xGrid.getCheckboxRecords()
      }
      this.$emit('returnForm', selectRecords)
      return selectRecords
      // this.clearTable();
    },
    clearTable () {
      this.$refs.xGrid.clearAll()
    }
  },
  factory: factory,
  watch: {
    formConfig () {
      this.gridOptions.formConfig = this.formConfig
    }
  }
}
</script>

<style scoped>
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-ghost,
.column-sortable-grid .vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}

.column-sortable-grid .vxe-header--row .vxe-header--column.col--fixed {
  cursor: no-drop;
}

</style>
